module.exports = __webpack_public_path__ + "media/slider/Banner-8-f842cedf.jpg";